import styled from '@emotion/styled'

export const Content = styled.div(
  ({ theme, color }) => `
  font-family: inherit;
  color: ${theme.ds.ColorBaseGreyLevel4};
  font-size: 12px;
  font-weight: normal;
  border-radius: 6px;
  padding: 4px 8px;
  background-color: ${color};
  max-height: 26px;
  box-sizing: border-box;
`
)
